import {
    SilSafetyFunction,
    SilSubsystem,
} from "server/models"
import {
    SilCalculationMethod,
    SilMode,
    OrderType,
} from "client/utils"

export interface SilSafetyFunctionProps {
    safetyFunctionId?: number
}

export interface SilSafetyFunctionList { [safetyFunctionId: number]: SilSafetyFunction }
export interface SilSafetyFunctionFilters {
    name?: string
    calculationMethod?: SilCalculationMethod
    mode?: SilMode
    calculated?: boolean
    search?: string
}

export type SilSafetyFunctionValidation = { [key in keyof SilSafetyFunction]?: string }

export interface SilSafetyFunctionState {
    baseRoute: string

    safetyFunctionList: SilSafetyFunctionList
    safetyFunctionIds: readonly number[]
    safetyFunctionView: SilSafetyFunction
    safetyFunctionEdit: SilSafetyFunction

    subsystemList: readonly SilSubsystem[]

    sortColumn: keyof SilSafetyFunction
    sortOrder: OrderType
    filters: SilSafetyFunctionFilters

    reloadList: boolean
    reloadView: boolean
    reloadEdit: boolean
}

export const SIL_SAFETY_FUNCTION_BASE_ROUTE = "SIL_SAFETY_FUNCTION_BASE_ROUTE"

export const SIL_SAFETY_FUNCTION_LIST = "SIL_SAFETY_FUNCTION_LIST"
export const SIL_SAFETY_FUNCTION_IDS = "SIL_SAFETY_FUNCTION_IDS"
export const SIL_SAFETY_FUNCTION_VIEW = "SIL_SAFETY_FUNCTION_VIEW"
export const SIL_SAFETY_FUNCTION_EDIT = "SIL_SAFETY_FUNCTION_EDIT"

export const SIL_SAFETY_FUNCTION_SUBSYSTEM_LIST = "SIL_SAFETY_FUNCTION_SUBSYSTEM_LIST"

export const SIL_SAFETY_FUNCTION_SORT = "SIL_SAFETY_FUNCTION_SORT"
export const SIL_SAFETY_FUNCTION_FILTERS = "SIL_SAFETY_FUNCTION_FILTERS"

export const SIL_SAFETY_FUNCTION_RELOAD_LIST = "SIL_SAFETY_FUNCTION_RELOAD_LIST"
export const SIL_SAFETY_FUNCTION_RELOAD_VIEW = "SIL_SAFETY_FUNCTION_RELOAD_VIEW"
export const SIL_SAFETY_FUNCTION_RELOAD_EDIT = "SIL_SAFETY_FUNCTION_RELOAD_EDIT"
